import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Cloud Function endpoint for secure config
const CONFIG_ENDPOINT = 'https://us-central1-gourmet-haus-524a3.cloudfunctions.net/getFirebaseConfig';

// Initialize Firebase
let app = null;
let auth = null;
let db = null;
let analytics = null;

// Fetch config from Cloud Function and initialize
async function initializeFirebaseApp() {
  try {
    const response = await fetch(CONFIG_ENDPOINT);
    if (!response.ok) {
      throw new Error(`Failed to fetch config: ${response.status}`);
    }
    
    const firebaseConfig = await response.json();
    
    if (firebaseConfig.apiKey && firebaseConfig.projectId) {
      app = initializeApp(firebaseConfig);
      auth = getAuth(app);
      db = getFirestore(app);
      
      // Initialize analytics only in production
      if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
        analytics = getAnalytics(app);
      }
      
      console.log('Firebase initialized successfully from Cloud Function');
      return true;
    } else {
      console.warn('Firebase configuration invalid');
      return false;
    }
  } catch (error) {
    console.error('Error initializing Firebase:', error);
    return false;
  }
}

// Initialize on module load
const initPromise = initializeFirebaseApp();

// Export a promise that resolves when Firebase is ready
export const firebaseReady = initPromise;
export { auth, db, analytics };
export default app;
